import {MAX_NUMBER_VALUE} from 'src/constants';

import type {CommonLimitDictionaryItem} from 'src/openapi/admin/models/CommonLimitDictionaryItem';
import type {Limit} from 'src/openapi/admin/models/Limit';

type GetUsageLimitsHeaders = (
    dictionary: CommonLimitDictionaryItem[],
    includeTotal: boolean,
    includeUsed: boolean
) => Record<string, string>;
export const getUsageLimitsHeaders: GetUsageLimitsHeaders = (
    dictionary,
    includeTotal,
    includeUsed,
) => {
    const entries: string[][] = [];

    dictionary.forEach(({description, children}) => {
        if (children) {
            children.forEach(child => {
                if (includeUsed) {
                    entries.push([`${child.code}_used`, `${description} - ${child.description} (used)`]);
                }
                if (includeTotal) {
                    entries.push([`${child.code}_total`, `${description} - ${child.description} (overall)`]);
                }
            });
        }
    });

    return Object.fromEntries(entries);
};

type GetUsageLimitsValuesProps = {
    dictionary: CommonLimitDictionaryItem[],
    includeTotal: boolean,
    includeUsed: boolean,
    usageLimits?: Limit[],
    usedLimits?: Limit[],
};
type GetUsageLimitsValues = (props: GetUsageLimitsValuesProps) => Record<string, string>;
export const getUsageLimitsValues: GetUsageLimitsValues = ({
    dictionary,
    includeUsed,
    includeTotal,
    usageLimits,
    usedLimits,
}) => {
    const entries: string[][] = [];

    dictionary.forEach(({children}) => {
        if (children) {
            children.forEach(child => {
                const overallLimit = usageLimits?.find(item => item.limitId === child.code);
                const usedLimit = usedLimits?.find(item => item.limitId === child.code);

                if (includeUsed) {
                    entries.push([`${child.code}_used`, usedLimit?.value ? usedLimit.value.toString() : '']);
                }
                if (includeTotal && overallLimit) {
                    entries.push([
                        `${child.code}_total`,
                        overallLimit.value === MAX_NUMBER_VALUE ? 'Unlimited' : overallLimit.value.toString(),
                    ]);
                } else if (includeTotal) {
                    entries.push([`${child.code}_total`, '']);
                }
            });
        }
    });

    return Object.fromEntries(entries);
};
